const StartStudying = () => (
    <div />
);

export default StartStudying;
